export default "__VITE_ASSET__Bz4Xm26M__"